import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  return '₹' + Number(amount || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getStatusColor(status) {
  const colors = {
    ACTIVE: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    PENDING: 'bg-amber-50 text-amber-700 border-amber-200',
    SUSPENDED: 'bg-red-50 text-red-700 border-red-200',
    INACTIVE: 'bg-slate-100 text-slate-600 border-slate-200',
    DRAFT: 'bg-slate-100 text-slate-600 border-slate-200',
    GENERATED: 'bg-blue-50 text-blue-700 border-blue-200',
    PAID: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    PARTIAL: 'bg-amber-50 text-amber-700 border-amber-200',
    OVERDUE: 'bg-red-50 text-red-700 border-red-200',
  };
  return colors[status] || 'bg-slate-100 text-slate-600 border-slate-200';
}

export function getContractTypeColor(type) {
  return type === 'EXCLUSIVE' 
    ? 'bg-purple-50 text-purple-700 border-purple-200'
    : 'bg-slate-50 text-slate-600 border-slate-200';
}

export function getAttachRateColor(rate) {
  if (rate >= 90) return 'text-emerald-600';
  if (rate >= 70) return 'text-amber-600';
  return 'text-red-600';
}

export function getAttachRateBg(rate) {
  if (rate >= 90) return 'bg-emerald-500';
  if (rate >= 70) return 'bg-amber-500';
  return 'bg-red-500';
}

export function getRoleLabel(role) {
  const labels = {
    SUPER_ADMIN: 'Super Admin',
    SHOP_OWNER: 'Shop Owner',
    STORE_MANAGER: 'Store Manager',
    SALES_STAFF: 'Sales Staff',
    SUPPORT_AGENT: 'Support Agent',
  };
  return labels[role] || role;
}

export function downloadCSV(data, filename) {
  if (!data || data.length === 0) return;
  
  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.join(','),
    ...data.map(row => 
      headers.map(h => {
        const val = row[h];
        if (val === null || val === undefined) return '';
        const str = String(val);
        return str.includes(',') || str.includes('"') || str.includes('\n')
          ? `"${str.replace(/"/g, '""')}"`
          : str;
      }).join(',')
    )
  ].join('\n');
  
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
}
